import {useEffect, useState} from 'react';
import { SidebarItem, SidebarSubmenu, SidebarSubmenuItem} from '@backstage/core-components';
import SpeedIcon from "@material-ui/icons/Speed";
import {useApi} from "@backstage/core-plugin-api";
import {dashboardApiRef} from "../../api";
import {DashboardInfo} from "@internal/backstage-plugin-dashboard-backend";

export const DashboardSidebarItem = () => {
    const dashboardApi = useApi(dashboardApiRef);
    const [availableDashboards, setAvailableDashboards] = useState<DashboardInfo[]>([]);
    useEffect(() => {
        dashboardApi.getAvailableDashboards()
            .then(availableDashboardsResult => setAvailableDashboards(availableDashboardsResult))
            .catch(error => { throw new Error(`Error while fetching available dashboards: ${error}`) });
    }, [dashboardApi]);

    let dashboardSubmenuItems: React.JSX.Element[] = [];
    if (availableDashboards) {
        dashboardSubmenuItems = availableDashboards.map(dashboard =>
            (<SidebarSubmenuItem
                key={dashboard.id}
                title={dashboard.dashboard_title}
                to={`dashboard/${dashboard.id}`}
            />)
        );
    }

    return (
        <SidebarItem icon={SpeedIcon} text="Dashboards">
            <SidebarSubmenu title="Dashboards">{dashboardSubmenuItems}</SidebarSubmenu>
        </SidebarItem>
    );
}
